import { GameState, LobbyState } from "../types";

/**
 * Who becomes President once the current term or vote is over. The server sends this (it knows about
 * special elections); the fallback is the next living player after the President in seating order.
 */
export function getNextPresident(game: GameState): string | undefined {
  if (game.nextPresident && game.players[game.nextPresident]) {
    return game.nextPresident;
  }
  const order = game.playerOrder;
  const start = order.indexOf(game.president);
  if (start < 0) {
    return undefined;
  }
  for (let i = 1; i < order.length; i++) {
    const candidate = order[(start + i) % order.length];
    if (game.players[candidate].alive) {
      return candidate;
    }
  }
  return undefined;
}

/**
 * True once the vote on this government has failed (or the election tracker enacted a policy), while the
 * President still has to end the term. The nominee is then not Chancellor and must not be shown as one.
 */
export function governmentFailed(game: GameState): boolean {
  if (game.state !== LobbyState.POST_LEGISLATIVE || !game.history || game.history.length === 0) {
    return false;
  }
  const outcome = game.history[game.history.length - 1].outcome;
  return outcome === "REJECTED" || outcome === "CHAOS_LIBERAL" || outcome === "CHAOS_FASCIST";
}

/** True while the player may not be nominated Chancellor: the last Chancellor, and the last President if more than 5 live. */
export function isTermLimited(game: GameState, name: string): boolean {
  const living = game.playerOrder.filter((p) => game.players[p].alive).length;
  return game.lastChancellor === name || (game.lastPresident === name && living > 5);
}
